<template>
  <div id="app" ref="scrollToTopElement">
    <index></index>
  </div>
</template>
<script>
import { getWechatConfig } from '@/api/getAPI';
import VConsole from 'vconsole';
import WX from 'weixin-js-sdk';
import index from '@/views/index.vue';
export default {
  name: 'App',
  components: { index },

  data() {
    return {};
  },
  created() {
    let token = localStorage.getItem('token');
    let userinfo = JSON.parse(localStorage.getItem('userinfo'));
    if (token && userinfo) {
      this.$store.dispatch('user/changeToken', token);
      this.$store.dispatch('user/changeUser', userinfo);
    }
  },
  mounted() {
    // const vConsole = new VConsole();
    // this.checkDeviceType();
    this.getWXConfig();
    // this.$nextTick(() => {
    //   window.addEventListener('popstate', function (event) {
    //     console.log('返回事件被捕捉');
    //     localStorage.setItem('routerReturn', 0);

    //   });
    // });
  },
  watch: {
    $route: {
      handler: function () {
        this.$refs.scrollToTopElement.scrollTop = 0;
      },
      deep: true,
    },
  },
  methods: {
    getWXConfig() {
      // var url = encodeURIComponent(window.location.href.split("#")[0]);
      var url = encodeURIComponent(window.location.href);
      getWechatConfig(url).then((res1) => {
        if (res1.code == 200) {
          const res = { data: res1.data.data };
          WX.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: parseInt(res.data.timestamp), // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: res.data.jsApiList, // 必填，需要使用的 JS 接口列表
          });
          WX.ready(() => {
            var shareData = {
              title: res1.data.share.title,
              desc: '',
              link: window.location.href,
              imgUrl: res1.data.share.image,
            };
            console.log(shareData);
            //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            WX.updateAppMessageShareData(shareData);
            //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
            WX.updateTimelineShareData(shareData);
          });
          //错误了会走 这里
          WX.error(function (res) {
            console.log('微信分享错误信息', res);
          });
        }
      });
    },
    // checkDeviceType() {
    //   const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    //   if (isMobile) {
    //     this.$alert('请在电脑端打开', {
    //       showConfirmButton: false,
    //       showCancelButton: false,
    //       showClose: false,
    //       confirmButtonText: '确定',
    //       callback: action => {
    //         this.$message({
    //           type: 'info',
    //           message: `action: ${ action }`
    //         });
    //       }
    //     });
    //     return
    //   }
    // }
  },
};
</script>

<style lang="less">
#app {
}

.el-message-box{
  width: 250px !important;
}

.el-message-box__content{
  text-align: center !important;
}
</style>
